import { BaseTag } from '@/components';
import { datetimeFormat } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  deadline: string;
};

export const WorkflowDeadlineTag: FC<Props> = ({ deadline }) => {
  const { t } = useTranslation();

  return (
    <BaseTag color="green">
      {t('until-date', {
        date: datetimeFormat({
          datetime: deadline,
          format: 'YYYY/MM/DD',
        }),
      })}
    </BaseTag>
  );
};
